const footerColumns = [
  {
    title: "站内导航",
    links: [
      { href: "#today", label: "今日更新节奏" },
      { href: "#reminder", label: "更新提醒设置" },
      { href: "#calendar", label: "追更日历打卡" },
    ],
  },
  {
    title: "内容分区",
    links: [
      { href: "#feed", label: "今日快讯流" },
      { href: "#comments", label: "热评互动区" },
      { href: "#faq", label: "常见问题" },
    ],
  },
  {
    title: "蹲更新必备",
    links: [
      { href: "#reminder", label: "开启更新提醒" },
      { href: "#calendar", label: "连续打卡记录" },
      { href: "#today", label: "每日更新节点表" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-background-50 font-heading text-xl font-bold text-primary-800">
                黑
              </span>
              <div>
                <div className="font-heading text-xl font-bold text-background-50">黑料每日</div>
                <div className="mt-1 text-xs text-primary-200">更新时间与提醒一站看全</div>
              </div>
            </div>
            <p className="mt-5 max-w-md text-xs leading-7 text-primary-100">
              每天 09:30 起分时段更新，19:00 晚间主推，23:00 出当日汇总。订阅更新提醒之后，
              重点场次开更就能收到推送，追更日历帮你规划蹲守节奏，吃瓜不迷路。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {["几点更新", "更新提醒", "追更日历", "打卡订阅"].map((kw) => (
                <span
                  key={kw}
                  className="rounded-full border border-primary-700 px-3 py-1.5 text-[11px] text-primary-100"
                >
                  {kw}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <h4 className="font-heading text-sm font-bold text-background-50">
                <a href="#top" className="cursor-pointer hover:text-accent-400">
                  {col.title}
                </a>
              </h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="cursor-pointer text-xs text-primary-100 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-1">
            <h4 className="font-heading text-sm font-bold text-background-50">
              <a href="#reminder" className="cursor-pointer hover:text-accent-400">
                订阅
              </a>
            </h4>
            <p className="mt-4 text-xs leading-6 text-primary-100">
              免费开启，
              <br />
              随时可关。
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-primary-700 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-primary-200">
            © 2026 黑料每日 · 本页为内容演示站点，所有信息仅供浏览参考
          </p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-primary-200">
            <a href="#faq" className="cursor-pointer hover:text-accent-400">
              免责说明
            </a>
            <a href="#comments" className="cursor-pointer hover:text-accent-400">
              社区规范
            </a>
            <a href="#reminder" className="cursor-pointer hover:text-accent-400">
              订阅须知
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}